/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { Radio } from "lucide-react";
import Layout from "@/components/Layout";
import { useLiveMatches } from "@/hooks/api/useMatches";
import LiveMatchCard from "@/pages/live-scorer/LiveMatchCard";
import NoLiveMatches from "@/pages/live-scorer/NoLiveMatches";

export default function LiveMatchScorer() {
  const { data: liveMatches, isLoading } = useLiveMatches();

  if (isLoading) {
    return (
      <Layout>
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600" />
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="mb-8">
        <div className="flex items-center gap-3">
          <Radio className="h-6 w-6 text-green-600 animate-pulse" />
          <div>
            <h1 className="text-3xl font-bold text-gray-900">
              Live Match Scorer
            </h1>
            <p className="text-gray-500 mt-1">
              Log real-time match events — points update instantly for all users
            </p>
          </div>
        </div>
      </div>

      {!liveMatches || liveMatches.length === 0 ? (
        <NoLiveMatches />
      ) : (
        <div className="space-y-8">
          {liveMatches.map((match) => (
            <LiveMatchCard key={match.id} match={match} />
          ))}
        </div>
      )}
    </Layout>
  );
}
